import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import {IFleetScore, IMachineryContext, ITrendBucket, ScorePeriod} from "../../../models/IDrivingScore";
import {drivingScoreAPI} from "../api/drivingScoreAPI";

interface FetchFleetOptions {
    company_id: string;
    period: ScorePeriod;
}

export const fetchFleetScore = createAsyncThunk<
    IFleetScore,
    FetchFleetOptions,
    { rejectValue: string }
>(
    'drivingScore/fetchFleet',
    async ({company_id, period}, {rejectWithValue}) => {
        try {
            return await drivingScoreAPI.getFleetScore(company_id, period);
        } catch (err) {
            const msg = axios.isAxiosError(err)
                ? err.response?.data?.message ?? err.message
                : 'Не удалось загрузить рейтинг стиля вождения';
            return rejectWithValue(msg);
        }
    },
);

export const fetchFleetTrend = createAsyncThunk<
    ITrendBucket[],
    FetchFleetOptions,
    { rejectValue: string }
>(
    'drivingScore/fetchFleetTrend',
    async ({company_id, period}, {rejectWithValue}) => {
        try {
            return await drivingScoreAPI.getFleetTrend(company_id, period);
        } catch (err) {
            const msg = axios.isAxiosError(err)
                ? err.response?.data?.message ?? err.message
                : 'Не удалось загрузить тенденцию парка';
            return rejectWithValue(msg);
        }
    },
);

interface FetchTrendOptions {
    machinery_id: string;
    period: ScorePeriod;
}

export const fetchMachineryTrend = createAsyncThunk<
    { machinery_id: string; trend: ITrendBucket[] },
    FetchTrendOptions,
    { rejectValue: string }
>(
    'drivingScore/fetchTrend',
    async ({machinery_id, period}, {rejectWithValue}) => {
        try {
            const trend = await drivingScoreAPI.getMachineryTrend(machinery_id, period);
            return {machinery_id, trend};
        } catch (err) {
            const msg = axios.isAxiosError(err)
                ? err.response?.data?.message ?? err.message
                : 'Не удалось загрузить тренд машины';
            return rejectWithValue(msg);
        }
    },
);

export const fetchMachineryContext = createAsyncThunk<{ machinery_id: string; context: IMachineryContext }, FetchTrendOptions, { rejectValue: string }>(
    'drivingScore/fetchContext',
    async ({machinery_id, period}, {rejectWithValue}) => {
        try {
            const context = await drivingScoreAPI.getMachineryContext(machinery_id, period);
            return {machinery_id, context};
        } catch (err) {
            const msg = axios.isAxiosError(err)
                ? err.response?.data?.message ?? err.message
                : 'Не удалось загрузить контекст машины';
            return rejectWithValue(msg);
        }
    },
);